import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SituacaoOrdemServicoComboService } from './situacao-ordem-servico-combo.service';
import { ComboBase } from 'src/app/models/comboModel';

@Component({
    selector: 'max-situacao-ordem-servico-combo',
    templateUrl: './situacao-ordem-servico-combo.component.html'
})
export class SituacaoOrdemServicoComboComponent implements OnInit {

    public lista!: ComboBase[];
    public selectedItem!: ComboBase;
    @Input() code: string = "";
    @Input() class!: string;
    @Input() selectedItemForm!: ComboBase;
    @Output() aoLimparSelecionado = new EventEmitter();
    @Output() itemSelecionado = new EventEmitter();

    constructor(private service: SituacaoOrdemServicoComboService) { }

    ngOnInit(): void {
        this.code = "";


        if (this.selectedItemForm != null) {
            this.code = this.selectedItemForm.code ? this.selectedItemForm.code : '';
            this.selectedItem = this.selectedItemForm;
        }
        this.getLista();
    }

    getLista() {
        this.service.getLista()
            .subscribe(
                (res) => {
                    if (res) {
                        this.lista = res;
                    }
                },
                err => {
                    console.log(`EtapaList ` + err);
                }
            );
    }

    onClear(event: any) {
        this.aoLimparSelecionado.emit(event);
    }
    onChange(event: any) {
        this.itemSelecionado.emit(event.value);
    }
}